import { useEffect, useState } from 'react';
import { adminGet } from './adminApi';
import { toast } from 'sonner';
import BfsiComplianceTab from './bfsi/BfsiComplianceTab';
import { GREEN } from './bfsi/bfsiShared';

export default function AdminCompliancePage() {
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    adminGet('/customers-lite').then(list => {
      setCustomers(list);
      if (list.length) setSelected(list[0].id);
    }).catch(e => toast.error(e.message));
  }, []);

  return (
    <div className="p-8 max-w-6xl" data-testid="admin-compliance-page">
      <h1 className="text-4xl font-bold mb-1" style={{ color: '#1B1D1C' }}>Compliance</h1>
      <p className="text-sm mb-5" style={{ color: '#9a9e96' }}>Per-customer compliance profile, maker-checker rules and audit evidence.</p>
      <div className="mb-6 max-w-xs">
        <label className="text-sm block mb-1" style={{ color: '#4b504a' }}>Customer</label>
        <select data-testid="compliance-customer-select" value={selected} onChange={e => setSelected(e.target.value)}
          className="w-full h-9 rounded-md border px-3 text-sm bg-white" style={{ borderColor: '#D9D6CD' }}>
          {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      {selected ? <BfsiComplianceTab tenantId={selected} key={selected} />
        : <div className="text-sm" style={{ color: GREEN }}>No customers yet</div>}
    </div>
  );
}
